
let NODE_ENV = window.XINPOC_DISPATCH_CONFIG && window.XINPOC_DISPATCH_CONFIG.isProject;
let title = {
  towway: "two way direct",
  icon: "I-CON",
  icp: "ICP",
};
export default {
  language: {
    name: 'English',
    title: 'language',
  },

  about: {
    title: title[NODE_ENV] || 'Global intercom dispatcher',
    conpanyname: 'Quanzhou Global-ptt Co., Ltd.',
    website: 'website',
  },
  login: {
    account: 'Enter login account',
    password: 'Enter password',
    installationServices: 'Install Speech Driver',
    rememberme: 'Remember me',
    Login: 'Log in',
    testaccount: 'test account',
    Password: 'Password'
  },
  message: {
    loginAccountTips: 'Login account can not be empty',
    loginPasswordTips: 'Password can not be empty',
    usernamePasswordTips: 'Incorrect username or password',
    loginsuccessful: 'login successful',
    accountNumbers: 'The account can only enter numbers!',
    noDispatcher: 'Login failed, the account is not a dispatcher!',
    accountNotpresent: 'Account does not exist!',
    LoginAbnormal: 'Login exception, please try again!',
    voiceServiceNotInstalled: 'Please install the voice service, if installed, please refresh the browser!',
    Videocallinprogress: 'Video call in progress!',
    Voicecallinprogress: 'Voice call in progress!',
    Youhavebeenclosedforspeaking: 'You have been turned off for speaking!',
    tctemporarygroup: 'Are you sure to refresh and exit the temporary group?',
    Doyouwanttologout: 'Do you want to log out?',
    prompt: 'hint',
    Nonetworklink: 'no internet connection',
    deletedGro: 'This group has been deleted and cannot be operated!',
    Pleaseselectthedesired: 'Please select the required',
    deletedGroUsers: 'User!',
    Pleaseselecttheusertotalkto: 'Please select the user to talk to',
    Voicecallfunction: 'Please enable the voice call function on the management platform first',
    Alreadytemporary: 'The users are already in a temporary group',
    Onlysupports: 'Only supports voice calls to a single user',
    Enablevoicecalls: 'This user has not enabled the voice call function on the management platform',
    Oncall: 'Cannot create while in call!',
    Shaketodeath: 'Shaking dead, cannot create',
    Shaketodeath2: 'Shaking dead, cannot switch groups',
    createregiongroups: 'You can only create up to 3 regional groups!',
    temporarygroupsnoadd: 'The user is already in a temporary group',
    haleDispatcherGroupUser: "Only members of the dispatcher's group can be forced",
    TemporaryGroupNoHale: 'The users are already in a temporary group and cannot be added',
    Groupcallfailure: 'Group call failed',
    Exitsuccessfully: 'exit successfully!',
    Usernotonline: 'User is offline!',
    Theotherpartyisbusy: 'The other party is busy!',
    Callfailed: 'Call failed!',
    Theotherpartyhashungup: 'The other party has hung up!',
    Networkconnectionfailed: 'Network connection failed, clear and try again later',
    Callended: 'call ended!',
    Accountpassworderror: 'account password error',
    Arrears: 'in arrears',
    Accountdoesnotexist: 'account does not exist',
    Permissionerror: 'permission error',
    AccountInfoChange: 'Account information has changed',
    Configuration: 'Configuration information error',
    accountOtherlogins: 'The account is already logged in elsewhere!',
    Accountlogintimeout: 'Account login timed out',
    Networkconnectionfailure: 'Network connection failed',
    Thenetworkisreconnecting: 'The network is reconnecting',
    Addinggroupfailed: 'Failed to join group',
    Addgrouprequesttimeout: 'Join group request timed out',
    Singlecallfailure: 'single call failure',
    Failedtojointhegroup: 'Failed to join group [permission error]',
    Failedtojointhegroup2: 'Failed to join group [does not exist]',
    Failedtojointhegroup3: 'Failed to join group [Expired]',
    Failedtojointhegroup4: 'Failed to join group [quota limit]',
    Failedtojointhegroup5: 'Failed to join group [valid object is empty]',
    noSnatchingwheat: 'Grabbing wheat multiple times in a short period of time is not allowed',
    noRemoteclosureSnatchingwheat: 'Grabbing microphones in remote closed state is not allowed',
    Failedtograbthewheat: 'Failed to apply for audio focus when grabbing microphones',
    Grabbingwheattimeout: 'Timed out when receiving the mic response',
    Failedtoopenrecordingdevice: 'Failed to open microphone device',
    Accountlocked: 'account is locked',
    Terminallocked: 'Terminal is locked',
    Machinecardlocked: 'card is locked',
    Noaccountinformationconfigured: 'No account information configured',
    Successfullysaved: 'Saved successfully!',
    Successfullysethost: 'Set host successfully!',
    Successfullydeleted: 'successfully deleted!',
    Successfullyadded: 'Added successfully!',
    Successfullyremoved: 'Removed successfully!',
    update_successfully: 'update completed',
    Successfullymodified: 'Successfully modified!',
    oldpassworderror: 'old password error',
    Parametererror: 'Parameter error',
    Pleaseselecttheuseryouwanttoadd: 'Please select the user to add',
    Addingfailed: 'Failed to add users,the user list is empty',
    Pleaseselectuserremoved: 'Please select the user to be removed',
    Removalfailed: 'Failed to remove users,the user list is empty',
    Prioritysetsuccessfully: 'Priority set successfully',
    Pleaseselectastartandendtime: 'Please select a start and end time',
    endTimeNoStarttime: 'End time cannot be earlier than start time',
    Thestartandendtimesmustbeonthesameday: 'Start time and end time must be on the same day',
    RedefineCustomization: 'The number of points in the custom area is less than 3, please re-draw',
    Unabletocreatetemporarygroup: 'There are currently no online members, unable to create a temporary group',
    Pleaseenteroldpassword: 'Please enter old password',
    Pleaseenteranewpassword: 'Please enter a new password',
    Confirmnewpassword: 'Confirm new password',
    noSamePassword: 'The old password cannot be consistent with the new password!',
    noSamePasswordTow: 'The passwords entered twice are inconsistent!',
    pleaseenterpasswordagain: 'please enter password again',
    Successfullyprocessed: 'Successfully processed',
    Useralreadyexists: 'User already exists',
    Insufficientpermissions: 'Insufficient permissions'
  },
  search: 'Search',
  users: 'user',
  refund: 'Back',
  Loadingdesperately: 'Desperately loading',
  Speaking: ' talking...',
  Iamspeaking: "I'm speaking...",
  communicatebytelephone: 'Call',
  call: 'Talk',
  hale: 'Force Join',
  Forceddemolition: 'Interrupt',
  confirm: 'Confirm',
  cancel: 'Cancel',
  dispatchIntercom: 'Dispatch',
  allGroups: 'all groups',
  fixedGroup: 'fixed groups',
  regionalGroup: 'regional group',
  filter: 'filter',
  all: 'all',
  online: 'online',
  offline: 'offline',
  groupUser: 'group/user',
  enter: 'Enter',
  edit: 'Edit',
  voiceIntercom: 'Voice intercom',
  baseStationSwitch: 'base station switch',
  gpsSwitch: 'GPS switch',
  viewHistoricalTrack: 'View historical track',
  startingtime1: 'Start Time',
  selectionPeriod: 'Select time',
  startingTime: 'Starting time',
  Pleaseselectadateandtime: 'Please select a start time',
  EndTime: 'End Time',
  Pleaseselectanendtime: 'Please select an end time',
  selectDate: 'select date',
  SelectStartTime: 'select start time',
  Now: 'now',
  Sure: 'Confirm',
  Closure: 'close',
  editArea: 'Edit area',
  deleteArea: 'Delete area',
  Areyousuretosavethefence: 'Are you sure you want to save the geofence?',
  deleteLocalgroup: 'Are you sure you want to delete the zone group?',
  pleaseselectaregion: 'Please search or circle the area first!',
  doubleclicktocreate: 'Double click to create',
  doubleclick: 'double click',
  Createregionalgroups: 'Create regional groups',
  groupName: 'group name',
  Pleaseenterthegroupname: 'Please enter a group name',
  pleaseenteragroupname: 'Please enter the group name (composed of 2-15 digits, Chinese and English)',
  groupnameTips: 'Group name must contain 2-15 characters',
  pleaseenteragroupnameTips: 'Must contain 2-15 characters',
  selectGroup: 'select group',
  Pinnedingroupusers: 'pinned in group users',
  TemporaryGroup: 'Temporary users in the group',
  Usernotingroup: 'Not-In group users',
  userImei: 'User/IMEI',
  Pleaseselectauser: 'Please select a user',
  Create: 'Create',
  Cancel: 'Cancel',
  groupEdit: 'Edit Group',
  usersingroup: 'In-Group users',
  UsernameImei: 'Username/IMEI',
  userName: 'User name',
  noData: 'No data',
  removeselectedusers: 'Remove selected users',
  Removeall: 'Remove all',
  Addtheselecteduser: 'Add selected users',
  Addall: 'Add all',
  Save: 'Save',
  selectUser: 'Add/Remove users',
  Edittakeseffect: 'edit takes effect',
  UserManagement: 'User Management',
  Userpriority: 'Speaking priority',
  levelone: 'Level one',
  Secondary: 'Level two',
  Levelthree: 'Level three',
  Levelfour: 'Level four',
  Fifthgrade: 'Level five',
  highest: 'highest',
  Editstakeeffectimmediately: 'Edits take effect immediately',
  Setmoderator: 'set host',
  SelectHost: 'choose host',
  Host: 'host',
  Pleasechoose: 'please choose',
  Deletemoderator: 'Delete host',
  Setuphost: 'Only one user can be set as host',
  Pleaseselectacall: 'Please choose what you want to call',
  Waitingforanswering: 'Wait for the other party to answer the voice',
  Inviteyoutovoicecall: 'invite you to voice call',
  callingusers: 'Please select the user to talk',
  Forcedpullusers: 'Please select the user who needs to be pulled',
  Forceddismantlingusers: 'Please select the user to interrupt',
  SearchLocation: 'search location',
  Show: 'show',
  Hide: 'hide',
  Default: 'default',
  Satellite: 'satellite',
  Roadconditions: 'Traffic',
  Toolbox: 'Tools',
  Ranging: 'Measure',
  Mark: 'mark',
  Broadcast: 'broadcast',
  EnableBroadcastGroup: 'Please enable the group to receive broadcasts first',
  textBroadcast: 'text broadcast',
  Hasbeensent: 'Has been sent',
  textBroadcastContent: 'Please enter the content of the text broadcast (no more than 50 characters)',
  pleaseentertextbroadcast: 'please enter text broadcast',
  Send: 'send',
  voiceBroadcast: 'voice broadcast',
  Clicktorecordvoicebroadcast: 'Click to record voice broadcast',
  Pleaserecordthevoicebroadcast: 'Please record the voice broadcast',
  RecordingTime: 'The recording time cannot be less than 1 second',
  Broadcaster: 'Broadcaster',
  BroadcastTime: 'broadcast time',
  listento: 'listen to',
  Warningmessage: 'warning message',
  AlarmHistory: 'For more warning messages, please check the history',
  Name: 'Name',
  Address: 'address',
  Time: 'time',
  Check: 'Check',
  State: 'state',
  Unprocessed: 'Unprocessed',
  DealWith: 'Handle',
  delete: 'Delete',
  PTTbuttondisplay: 'PTT button display',
  SOSalarmsound: 'SOS alarm sound',
  Fencealarmsound: 'Geofence warning sound',
  Motiontrajectorybinding: 'Motion track tie road',
  Changepassword: 'Change Password',
  Logoutoflogin: 'Logout',
  Dataanalysis: 'Analytics',
  Statisticstoday: "Today's statistics",
  Currentonlineusers: 'Current online users',
  Totalnumberofusers: 'Total users',
  Fencerecord: 'Geofence record',
  SOSrecord: 'SOS records',
  recordingrecord: 'Audio recordings',
  Grouponlineusers: 'Online users by group',
  Comparison: 'Online users in the last 7 days',
  warningcomparison: '30-day alarm comparison',
  Fencewarning: 'Geofence',
  SOSwarning: 'SOS',
  OldPassword: 'Old Password',
  NewPassword: 'New Password',
  ConfirmPassword: 'Confirm Password',
  consists: 'Consists of 6-16 letters and numbers',
  startingpoint: 'starting point',
  totallength: 'total length',
  ico: 'ico',
  date: 'Date',
  Targeting: 'Positioning',
  Basestationpositioning: 'Base station positioning',
  BeidouGPS: 'Beidou/GPS',
  direction: 'Direction',
  altitude: 'Altitude',
  Speed: 'Speed(km/h)',
  warmreminder: 'Note: This data is provided by a third party and may contain inaccuracies. For reference only.',
  Iconselection: 'Icon selection',
  pleaseentername: 'Please enter name',
  changeicon: 'Change icon',
  Universal: 'Universal',
  policesecurity: 'police security',
  Firefighting: 'Firefighting',
  Chemicalindustry: 'Chemical industry',
  other: 'other',
  save: 'Save',
  close: 'Close',
  viewtag: 'View tag',
  addtag: 'Add tag',
  Supportsaddingamaximum: 'Supports adding a maximum of 10 icons',
  Imageformaterror: 'Image format error',
  uploadedimage: 'The size of the uploaded image cannot exceed 5kb!',
  uploadsuccessful: 'Upload successful',
  uploadfailed: 'upload failed',
  uploadfailedimage: 'Upload failed: The maximum pixel size of the image is 25×25!',
  Successfuloperation: 'Successful operation',
  operationfailed: 'operation failed',
  Editmark: 'Edit mark',
  Pleaseselecttheiconyouwanttodelete: 'Please select the icon you want to delete',
  successfullydeleted: 'successfully deleted',
  failedtodelete: 'failed to delete',
  north: 'north',
  South: 'South',
  West: 'West',
  East: 'East',
  truenorth: 'true north',
  duesouth: 'due south',
  duewest: 'due west',
  Zhengdong: 'Zhengdong',
  partial: ' partial',
  historyrecord: 'History',
  group: 'Group',
  pleaseselectagroup: 'Please select a group',
  sender: 'Sender',
  Pleaseselectuser: 'Please select user',
  Sendtime: 'Sent time',
  startrange: 'From',
  endrange: 'To',
  startdate: 'start date',
  Startingtime: 'Starting time',
  enddate: 'end date',
  to: 'to',
  Clear: 'Clear',
  Confirm: 'Confirm',
  state: 'Status',
  Pleaseselectastatus: 'Please select a status',
  Processed: 'Processed',
  Processor: 'Handled by',
  processtime: 'Time',
  serialnumber: 'No.',
  operate: 'Actions',
  ViewSOSlocation: 'View SOS location',
  Back: 'Back',
  Warmreminder: 'Warm reminder: The data comes from a third party and may contain errors. It is for reference only.',
  SOSalarmsintemporarygroupsarenotrecorded: 'SOS alarms in temporary groups are not recorded.',
  Pleaseselectatype: 'Please select a type',
  deleted: 'deleted',
  next: 'next',
  Tobeprocessed: 'Unprocessed',
  dealwith: 'Handle',
  alreadydispatched: 'Already dispatched',
  temporarygroup: 'temporary group',
  NortheasternHemisphere: 'Northeastern Hemisphere',
  northwesternhemisphere: 'northwestern hemisphere',
  SoutheasternHemisphere: 'Southeastern Hemisphere',
  southwesternhemisphere: 'southwestern hemisphere',
  Nolocationtrack: 'No location track found',
  Latitudeandlongitude: 'Latitude and longitude',
  Reportingtime: 'Reporting time',
  Positioningtime: 'Positioning time',
  Alarminformation: 'Alert details',
  AlarminformationTips: 'For more alerts, please view the history page.',
  initiatesos: 'initiate sos',
  Forcedvideo: 'Forced video',
  videocall: 'video call',
  Videopostback: 'Video postback',
  leave: 'leave',
  Enter: 'Enter',
  fence: 'Geofence',
  newgroup: 'Create group',
  Joingroup: 'Join group',
  Thegroupnamealreadyexistspleasereenterit: 'The group name already exists, please re-enter it.',
  Groupcreatedsuccessfully: 'Group created successfully',
  Groupcreationfailedpleasecreateagain: 'Group creation failed, please create again!',
  Pleaseenterthegrouppassword: 'Please enter the group password',
  Thegrouppasswordyouenterediswrong: 'The group password you entered is wrong',
  Grouppassword: 'Group password',
  Dissolve: 'Dissolve',
  Exit: 'Leave',
  Disbandselforganizedgroup: 'Dissolve Group',
  Exittheselfcreatedgroup: 'Leave Group',
  ExiDissolvetheselfestablishedgroupt: 'Are you sure you want to dissolve this self-created group?',
  Exitselfbuiltgroup: 'Are you sure you want to leave this self-created group?',
  Grouptransfer: 'Group transfer',
  Theusersselfbuiltgroupfunctionisnotopened: "The user's self -built group function is not opened",
  sosrecord: 'SOS records',
  UnhandledSOSexists: 'Unhandled SOS exists',
  Createfence: 'Create geofence',
  Editfence: 'Edit geofence',
  electricfence: 'Geofence',
  Electronicfencelist: 'Geofence list',
  fencename: 'Geofence name',
  efficient: 'Active',
  Invalid: 'lnactive',
  Forbidden: 'No exit',
  Noentry: 'No entry',
  Pleasesearchorselfselectthefencedareafirst: 'Please first select an area on the map',
  Areyousureyouwanttodeletetheelectronicfence: 'Are you sure you want to delete the geofence?',
  Triggermode: 'Trigger mode',
  timesetting: 'Time settings',
  Pleaseenterthefencename: 'Please enter the geofence name',
  tipsItconsists: 'Must contain 1-15 characters',
  tipsItconsistsName: 'Geofence name consists of 1-15 characters',
  Pleaseselectamethodofentryandexit: 'Please select a method of entry and exit',
  Pleaseselectatleastoneday: 'Please select at least one day',
  Notinfenceusers: 'Not-in geofence users',
  Usersonthefence: 'In geofence users',
  Validdate: 'Date range',
  Validperiod: 'Time range',
  Selecttimerange: 'Select time range',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Createdsuccessfully: 'Created successfully',
  Thefencenameisduplicated: 'The geofence name is duplicated, please modify it and try again.',
  Ifnotselected: 'If not selected, the default is permanently valid.',
  FenceEdit: 'Edit Geofence',
  Removalfailedfence: 'Removal failed, the geofence user list is empty',
  Failedtoaddfence: 'Failed to add, the list of users not in the geofence is empty',
  Outofboundsrecord: 'Geofence history',
  Outofboundstype: 'Violation type',
  Pleaseselectausername: 'Please select a username',
  Pleaseselecttriggermethod: 'Please select Trigger mode',
  Crossborderdate: 'Violation date',
  currentrecord: 'current record',
  Triggertime: 'Triggered at',
  Pleaseselectafencename: 'Please select a geofence name',
  Releasetime: 'Release time',
  Batchdownload: 'Batch download',
  Recordingplayback: 'Play recording',
  download: 'Download',
  Areyousureyouwant: 'Are you sure you want to download the selected recording?',
  Record: 'Record',
  Pleaseselecttherecording: 'Please select the recording you want to download',
  downloadsuccessful: 'download successful',
  Voiceaudio: 'Voice audio',
  text: 'text',
  voice: 'voice',
  Doubleclicktocreate: 'Double click to create',
  Doubleclicktosave: 'Double click to save',
  outofboundsperson: 'out-of-bounds person',
  temporarygroupTow: 'temporary group',
  Theotherpartyhasnoanswer: 'The other party has no answer!',
  Existing: "Existing"
}
